import { JobType, JobItemType } from '@/common/enumerations';

export function findMatchingJobItemType(jobType: number): number {
  switch (jobType) {
    case JobType.Mixed:
      return 0;
    case JobType.Underground:
      return JobItemType.Underground;
    case JobType.Overhead:
      return JobItemType.Overhead;
    case JobType.Drafting:
      return JobItemType.Drafting;
    case JobType.Detailing:
      return JobItemType.Detailing;
    case JobType.ProjectManagement:
      return JobItemType.ProjectManagement;
    case JobType.Design:
      return JobItemType.Design;
    case JobType.UndergroundLocating:
      return JobItemType.UndergroundLocating;
    case JobType.Admin:
      return JobItemType.Admin;
    default:
      return 0;
  }
}
